export const REGION = "asia-southeast1";
// local
export const LOCAL_USER = "Local User";
// ref
export const REF = {
  OPERATOR: "operator",
  // user
  USER: "user",
  CLIENT: "client",
  ORDER: "order",

  //reseller
  RESELLER: "reseller",
};
